import { getContentfulSingingPortraitSongs } from 'api/contentful/memory'
import { AnalyticsEvent } from 'utils/analytics/event'
import { AnimationPricing } from 'utils/analytics/types'
import { ApiType } from 'utils/types'

/**
 * This event is fired after a isnging portrait is finished.
 */
export const sh_finished = new AnalyticsEvent<ApiType['MemoryFileResponse']>({
  async onFire(ctx) {
    const animation = ctx.args
    const songs = await getContentfulSingingPortraitSongs()
    const song = songs.find((song) => song.driverId === animation.driver_type)
    ctx.fireEvent('sh_finished', {
      pricing: animation.animation_source_type?.toLowerCase() as AnimationPricing,
      song_name: String(song?.songName),
    })
  },
})
